// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3fNzD","bigColWidth":"Table_bigColWidth__16Z--","biggerColWidth":"Table_biggerColWidth__27stB","row":"Table_row__2SiM2","col":"Table_col__2SC4i"};